// TODO: (A.H.) - need to add to vocabulary.
export const PLACEHOLDER = 'Choose option';
export const NO_FOUND_ITEMS = 'No found items';
